<app-banner></app-banner>

<div id="side-navigation">
  <div class="container-fluid p-0">
    <div class="row g-0">

      <!-- IQAC Sidebar (hide when inside Best Practices section) -->
      <div
        class="col-12 col-md-4 col-lg-3 side-menu"
        *ngIf="!isBestPracticesPage"
      >
        <h6>IQAC</h6>
        <ul class="nav flex-column">
          <li class="nav-item" routerLinkActive="active">
            <a class="nav-link" routerLink="/iqac/about-iqac">About IQAC</a>
          </li>
          <li class="nav-item" routerLinkActive="active">
            <a class="nav-link" routerLink="/iqac/formation">Formation of IQAC</a>
          </li>
          <li class="nav-item" routerLinkActive="active">
            <a class="nav-link" routerLink="/iqac/iqac-meetings">IQAC Meetings</a>
          </li>
          <li class="nav-item" routerLinkActive="active">
            <a
              class="nav-link"
              routerLink="/iqac/institutional-dist"
              >Institutional Distinctiveness</a
            >
          </li>
          <li class="nav-item" routerLinkActive="active">
            <a class="nav-link" routerLink="/iqac/best-prac">Best Practices</a>
          </li>
          <li class="nav-item" routerLinkActive="active">
            <a
              class="nav-link"
              routerLink="/iqac/quality-initiatives"
              >Quality Initiatives</a
            >
          </li>
          <li class="nav-item" routerLinkActive="active">
            <a class="nav-link" routerLink="/iqac/quality-audits">Quality Audits</a>
          </li>
          <li class="nav-item" routerLinkActive="active">
            <a
              class="nav-link"
              routerLink="/iqac/collaborative-initiatives"
              >Collaborative Initiatives</a
            >
          </li>
          <li class="nav-item" routerLinkActive="active">
            <a
              class="nav-link"
              routerLink="/iqac/conferences-seminars-workshops"
              >Seminars & Workshops</a
            >
          </li>
          <li class="nav-item" routerLinkActive="active">
            <a class="nav-link" routerLink="/iqac/aishe">AISHE</a>
          </li>
          <li class="nav-item" routerLinkActive="active">
            <a class="nav-link" routerLink="/iqac/nirf">NIRF</a>
          </li>
          <li class="nav-item" routerLinkActive="active">
            <a class="nav-link" routerLink="/iqac/aqar">AQAR</a>
          </li>
          <li class="nav-item" routerLinkActive="active">
            <a
              class="nav-link"
              routerLink="/iqac/accreditation"
              >Accreditation</a
            >
          </li>
          <li class="nav-item" routerLinkActive="active">
            <a class="nav-link" routerLink="/iqac/feedback">Feedback Analysis</a>
          </li>
        </ul>
      </div>

      <!-- Main Content (adjusts full width if Best Practices) -->
      <div
        class="col-12"
        [class.col-md-8]="!isBestPracticesPage"
        [class.col-lg-9]="!isBestPracticesPage"
      >
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</div>
